import { render, staticRenderFns } from "./CharacterDeletingText.vue?vue&type=template&id=15f7822a&lang=pug&"
import script from "./CharacterDeletingText.vue?vue&type=script&lang=js&"
export * from "./CharacterDeletingText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterDeletingText.vue"
export default component.exports